import { connect } from 'react-redux'
import AttachmentAgreementWidget from './AttachmentAgreementWidget'
import {isAttachmentProviderStore} from '../../../globals/state/selector'
import { selectCustomer } from '../../../customer/state/detail/selector'
import * as action from '../../../anamnesis/state/anamnesis/action'
import {selectIsFetching, selectMedicalAssessment} from "../../../anamnesis/state/anamnesis/selector";
import {selectIsTaskReadOnly} from "../../state/task-detail/selector";
import {selectLastMedicalAssessment} from "../../../anamnesis/state/list/selector";

const mapStateToProps = (state, props) => {
    const customer = selectCustomer(state)
    const readOnly = typeof props.readOnly === "boolean" ? props.readOnly : selectIsTaskReadOnly(state)
    const anamnesis = readOnly ? selectLastMedicalAssessment(state) : selectMedicalAssessment(state)

    return {
        anamnesis,
        readOnly,
        fetching: selectIsFetching(state),
        isAttachmentProviderStore: isAttachmentProviderStore(state, customer.store),
    }
}

const mapDispatchToProps = {
    changeAnamnesis: action.changeAnamnesis,
    saveAnamnesis: action.saveAnamnesis,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AttachmentAgreementWidget)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/AttachmentAgreementWidgetContainer.js